import React from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'

export interface PreferenceOptions {
  title: string
  icon: string
  fuel?: number
  fare?: number
  tolls?: number
  parking?: number
  toFrom?: string
  timeToTravel?: string
  totalCost: number
  totalTime: string
}

interface PreferenceInputProps {
  preferenceOptions: PreferenceOptions[]
  updatePreferenceOptions: (optionData: PreferenceOptions, optionIndex: number) => void
  AddNewOption: () => void
  deleteOption: (optionIndex: number) => void
}

const PreferenceInput: React.FC<PreferenceInputProps> = ({
  preferenceOptions,
  updatePreferenceOptions,
  AddNewOption,
  deleteOption,
}) => {
  const handleTitleChange = (e: React.FormEvent<HTMLInputElement>, index: number) => {
    const updatedOption = {
      ...preferenceOptions[index],
      title: e.currentTarget.value,
    }
    updatePreferenceOptions(updatedOption, index)
  }

  const handleFieldChange = (
    field: keyof PreferenceOptions,
    value: string | number,
    index: number
  ) => {
    const updatedOption = {
      ...preferenceOptions[index],
      [field]: value,
    }
    updatePreferenceOptions(updatedOption, index)
  }

  const handleAddOption = () => {
    AddNewOption()
  }

  const handleDeleteOption = (optionIndex: number) => {
    if (preferenceOptions.length === 1) return
    deleteOption(optionIndex)
  }

  return (
    <div className='my-4 ml-2'>
      <div className='flex flex-col gap-4'>
        {preferenceOptions.map((option, index) => {
          return (
            <div key={index} className='border rounded-lg p-4 border-gray-600'>
              {/* Option Title Row */}
              <div className='flex items-center gap-1 md:gap-2 mb-3'>
                <input
                  type='text'
                  placeholder={`Option ${index + 1} Title`}
                  className='form-control form-control-solid flex-grow'
                  value={option.title}
                  onChange={(e) => handleTitleChange(e, index)}
                />
                <select
                  className='form-select form-select-sm w-200px'
                  placeholder='Icon'
                  value={option.icon}
                  onChange={(e) => handleFieldChange('icon', e.target.value, index)}
                >
                  <option value='car'>car</option>
                  <option value='taxi'>taxi</option>
                  <option value='bus'>bus</option>
                  <option value='rail'>rail</option>
                  <option value='metro'>metro</option>
                </select>
                <button
                  className='rounded-lg bg-red-300 p-2 md:ml-4 hover:bg-red-400 transition'
                  type='button'
                  onClick={() => handleDeleteOption(index)}
                >
                  <KTIcon iconName='trash' className='fs-3' />
                </button>
              </div>

              {/* Detailed Fields */}
              <div className='grid grid-cols-2 md:grid-cols-4 gap-3 ml-8'>
                <div>
                  <label className='text-sm font-medium mb-1 block'>Fuel (AED)</label>
                  <input
                    type='number'
                    placeholder='0'
                    className='form-control form-control-sm'
                    value={option.fuel || ''}
                    onChange={(e) =>
                      handleFieldChange('fuel', parseFloat(e.target.value) || 0, index)
                    }
                  />
                </div>

                <div>
                  <label className='text-sm font-medium mb-1 block'>Fare (AED)</label>
                  <input
                    type='number'
                    placeholder='0'
                    className='form-control form-control-sm'
                    value={option.fare || ''}
                    onChange={(e) =>
                      handleFieldChange('fare', parseFloat(e.target.value) || 0, index)
                    }
                  />
                </div>

                <div>
                  <label className='text-sm font-medium mb-1 block'>Tolls (AED)</label>
                  <input
                    type='number'
                    placeholder='0'
                    className='form-control form-control-sm'
                    value={option.tolls || ''}
                    onChange={(e) =>
                      handleFieldChange('tolls', parseFloat(e.target.value) || 0, index)
                    }
                  />
                </div>

                <div>
                  <label className='text-sm font-medium mb-1 block'>Parking (AED)</label>
                  <input
                    type='number'
                    placeholder='0'
                    className='form-control form-control-sm'
                    value={option.parking || ''}
                    onChange={(e) =>
                      handleFieldChange('parking', parseFloat(e.target.value) || 0, index)
                    }
                  />
                </div>

                <div>
                  <label className='text-sm font-medium mb-1 block'>To/From</label>
                  <input
                    type='text'
                    placeholder='Location details'
                    className='form-control form-control-sm'
                    value={option.toFrom || ''}
                    onChange={(e) => handleFieldChange('toFrom', e.target.value, index)}
                  />
                </div>

                <div>
                  <label className='text-sm font-medium mb-1 block'>Time to Travel</label>
                  <input
                    type='text'
                    placeholder='e.g., 30 mins'
                    className='form-control form-control-sm'
                    value={option.timeToTravel || ''}
                    onChange={(e) => handleFieldChange('timeToTravel', e.target.value, index)}
                  />
                </div>

                <div>
                  <label className='text-sm font-medium mb-1 block'>Total Cost (AED)</label>
                  <input
                    type='number'
                    placeholder='0'
                    className='form-control form-control-sm'
                    value={option.totalCost}
                    onChange={(e) =>
                      handleFieldChange('totalCost', parseFloat(e.target.value) || 0, index)
                    }
                  />
                </div>

                <div>
                  <label className='text-sm font-medium mb-1 block'>Total Time</label>
                  <input
                    type='text'
                    placeholder='e.g., 1 hour'
                    className='form-control form-control-sm'
                    value={option.totalTime}
                    onChange={(e) => handleFieldChange('totalTime', e.target.value, index)}
                  />
                </div>
              </div>
            </div>
          )
        })}

        <div className='my-2 ml-8'>
          <button type='button' className='btn btn-secondary btn-sm' onClick={handleAddOption}>
            + Add Option
          </button>
        </div>
      </div>
    </div>
  )
}

export default PreferenceInput
